import { render, staticRenderFns } from "./ServiceEditModal.vue?vue&type=template&id=5ffd5082&"
import script from "./ServiceEditModal.vue?vue&type=script&lang=js&"
export * from "./ServiceEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports